module.exports = __webpack_public_path__ + "static/media/Diceroll.88628dc3.mp3";